import { Card, Typography } from "antd";
import React from "react";

const { Text, Title } = Typography;

type Props = {
  label: string;
  total: number | string; // Total value for reference
};

const DashboardTotalCard: React.FC<Props> = ({ label, total }) => {
  return (
    <Card className="dashboard-rectangle-card">
      <div className="dashboard-total-values">
        <div className="dashboard-values-wrapper">
          <Text className="dashboard-title">{label}</Text>
          <b className="dashboard-count">{total}</b>
        </div>
      </div>
    </Card>
  );
};

export default DashboardTotalCard;
